import * as React from 'react';
import { Link } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import { clean } from 'src/shared/utils/props';
import './button.sass';
import { FaChevronDown } from 'react-icons/fa';

const baseClasses = 'element--button h-36 lh-34 fs-14 br-4 py-0 px-12 fw-700';

export const Button = ({
  type = 'button',
  disabled,
  children,
  $loading,
  $spinner,
  $loadingText,
  ...props
}) => {
  return (
    <button
      type={type}
      disabled={disabled || $loading}
      {...clean(props, baseClasses)}
    >
      {$loading ? ($spinner ? <CircularProgress
        size={22}
        sx={{
          color: 'hsl(196deg 95% 50%)',
          marginTop: '6px',
        }} /> : ($loadingText || 'Please wait...')) : children}
    </button>
  );
};

export const LinkButton = (props) => {
  const Component = props.to ? Link : 'a';
  return (
    <Component {...clean(props, baseClasses)} />
  );
};

export const TextButton = (props) => {
  return (
    <button {...clean(props, 'element--text-button bc-none pa-0 pointer fc-primary-40 fw-600')} />
  );
};


export const DropdownButton = ({
  options,
  activeOption,
  onSelect,
  className,
  $loading,
  $spinner,
  $loadingText,
  disabled,
  ...props
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const dropdownRef = React.useRef(null);

  const handleToggleDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleSelect = (option) => {
    onSelect(option);
    setIsOpen(false);
  };

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="dropdown-button-container" ref={dropdownRef}>
      <div
        className={`${baseClasses} dropdown-button ${isOpen ? 'active' : ''} ${className || ''}  ${$loading || disabled ? 'disabled' : ''}`}
      >
        {$loading ? (
          $spinner ? (
            <CircularProgress
              size={22}
              sx={{
                color: 'hsl(196deg 95% 50%)',
                marginTop: '6px',
              }}
            />
          ) : (
            $loadingText || 'Please wait...'
          )
        ) : (
          <>
            <button
              className="button-content"
              disabled={disabled || $loading}
              {...props}
            >
              {activeOption
                ? options.find((option) => option.value === activeOption)?.label
                : 'Select an option'}
            </button>
            <div className="separator" />
            <div
              className="arrow-container right"
              onClick={handleToggleDropdown}
            >
              <FaChevronDown className={`arrow ${isOpen ? 'rotate' : ''}`} />
            </div>
          </>
        )}
      </div>
      {isOpen && (
        <ul className="dropdown-options">
          {options.map((option) => (
            <li
              key={option.value}
              onClick={() => handleSelect(option.value)}
              className={option.value === activeOption ? 'active' : ''}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
